import {
  CURRENCY_USD,
  USD_UNIT_CONVERSION_FACTOR,
  ZERO_DECIMAL_CURRENCIES,
} from 'constants/currency';

// TODO: Use Intl.NumberFormat as seen in stripeHelpers to convert, format, and display prices
// Write tests for this function and ensure it gets the same output

// NOTE: Do we need to do anymore to ensure we are only working with integers?
// We should be fine if we round all multiplication if we can trust priceUnitAmount
export const convertUnitPriceToFormattedPrice = (priceUnitAmount: number, currency: string) => {
  // Normalize currency code
  const currencyCode = currency.toUpperCase();
  const isUSD = currencyCode === 'USD';

  // Determine if we're dealing with a zero-decimal currency
  const isZeroDecimalCurrency = ZERO_DECIMAL_CURRENCIES.includes(currencyCode);

  // Calculate the formatted price value
  const priceFormatted = isZeroDecimalCurrency
    ? priceUnitAmount
    : priceUnitAmount / USD_UNIT_CONVERSION_FACTOR;

  // Use Intl.NumberFormat for standardized formatting
  let formatter;

  try {
    // Use narrowSymbol only for USD, use symbol for all other currencies
    formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: isUSD ? 'narrowSymbol' : 'symbol',
      minimumFractionDigits: isZeroDecimalCurrency ? 0 : 2,
      maximumFractionDigits: isZeroDecimalCurrency ? 0 : 2,
    });
  } catch (error) {
    // Fallback if the currency code is invalid
    console.error(`Invalid currency code: ${currencyCode}`, error);
    formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: CURRENCY_USD,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  // Format with full decimal precision
  const priceDisplayFull = formatter.format(priceFormatted);

  // Format removing trailing zeros for clean display
  let priceDisplay = priceDisplayFull;
  if (!isZeroDecimalCurrency && priceFormatted % 1 === 0) {
    // If it's a whole number, remove the decimal part
    priceDisplay = formatter.format(priceFormatted).replace(/\.00$/, '');
  }

  return {
    priceUnitAmount,
    priceFormatted: isZeroDecimalCurrency
      ? priceFormatted
      : priceFormatted % 1 === 0
      ? priceFormatted
      : parseFloat(priceFormatted.toFixed(2)),
    priceDisplay,
    priceDisplayFull,
  };
};
